import { render, staticRenderFns } from "./ClariveinPage.vue?vue&type=template&id=31196a56&scoped=true"
import script from "./ClariveinPage.vue?vue&type=script&lang=js"
export * from "./ClariveinPage.vue?vue&type=script&lang=js"
import style0 from "./ClariveinPage.vue?vue&type=style&index=0&id=31196a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31196a56",
  null
  
)

export default component.exports